import clsx from 'clsx';
import { useEffect, useState } from 'react';
import s from './GradientLiveBorder.scss';

// hook variation of https://github.com/wix-private/funnel-intro-next/blob/248410c/packages/wildcat-ui/src/components/GradientLiveBorder/GradientLiveBorder.tsx#L5
export const useGradientLiveBorder = ({ paused }: { paused?: boolean }) => {
  // this makes sure that full cycle finishes before pausing animation
  const [realPaused, setRealPaused] = useState(paused);

  useEffect(() => {
    !paused && setRealPaused(paused);
  }, [paused]);

  return {
    containerClassName: s.container,
    className: clsx(s.border, { [s.paused]: realPaused }),
    onAnimationIteration: () => {
      paused && setRealPaused(paused);
    },
  };
};
